import { ListShifts } from '~/domain/usecases/teleShifts/redux';

import {
  ShiftsTypes,
  iActionListShifts,
  iActionListShiftsFailed,
  iActionListShiftsSuccess,
} from '~/domain/interfaces/redux/teleShifts/list';

export const listShiftsRequest = (
  payload: ListShifts.Params,
): iActionListShifts => ({
  type: ShiftsTypes.GETALL,
  payload,
});

export const listShiftsSuccess = (
  params: ListShifts.Model,
): iActionListShiftsSuccess => ({
  type: ShiftsTypes.GETALL_SUCCESS,
  payload: params,
});

export const listShiftsFailed = (): iActionListShiftsFailed => ({
  type: ShiftsTypes.GETALL_FAILED,
});
